import {isAfter} from 'date-fns';

import {isNotNil} from 'ramda';

import type {MinipurchaseResponseBody} from '@dms/api/finance';

import type {InterestPlannedActivity} from '@prompt-bridge/shared/ai-assistant-core';

import {parseDate} from 'shared/web';

type ToFallbackTestDriveInput = {
  minipurchase: Pick<MinipurchaseResponseBody, 'id' | 'testDriveScheduledAt'> | null;
  evaluatedAt: string;
};

export const toFallbackTestDrive = (
  input: ToFallbackTestDriveInput
): InterestPlannedActivity | null => {
  const scheduledAt = input.minipurchase?.testDriveScheduledAt;
  return isNotNil(scheduledAt) &&
    isNotNil(input.minipurchase) &&
    isAfter(parseDate(scheduledAt), parseDate(input.evaluatedAt))
    ? {
        id: input.minipurchase.id,
        kind: 'testDrive',
        dueAt: scheduledAt,
        completed: false,
      }
    : null;
};
